import { defaultConfiguration, dialogTypePositions } from '../../../constants';

import { types as ActionTypes } from './Palette.actions';
import { types as ConfigActionTypes } from '../../ConfigDetails.actions';
import { genericReducer } from '/b2b/common/helpers/ReduxHelpers';

export const initialState = {
    ...defaultConfiguration.palette,
};

/*
 * This reducer merges each response into the palette already in state, so a key the response omits
 * keeps the previous config's value. `theme` is absent from every config saved before the selector
 * shipped, and a null one is stripped before storage — so without this, opening a legacy config
 * after a Modern one shows Modern and saves it onto the legacy config.
 *
 * Mirrors `responseFallbacks` in Configuration.reducer, which does the same for `variantMapping`.
 * The merge leaks every other omitted palette key too; that is older and wider than this fix.
 */
const responseFallbacks = state => ({ ...state, theme: null });

export default genericReducer(initialState, {
    [ConfigActionTypes.createSuccess]: (state, { response }) => {
        const { configuration: { palette = {} } = {} } = response;
        return {
            ...responseFallbacks(state),
            ...palette,
        };
    },
    [ConfigActionTypes.fetchDetailsSuccess]: (state, { response }) => {
        const { configuration: { palette = {} } = {} } = response;
        return {
            ...responseFallbacks(state),
            ...palette,
        };
    },
    [ConfigActionTypes.updateSuccess]: (state, { response }) => {
        const { configuration: { palette = {} } = {} } = response;
        return {
            ...responseFallbacks(state),
            ...palette,
        };
    },
    [ActionTypes.fieldChange]: (state, { field, value }) => {
        const newState = { ...state };
        switch (field) {
            case 'dialogType': {
                const positions = Object.keys(dialogTypePositions[value] || {});
                const index = positions.indexOf(newState.displayPosition);
                newState.displayPosition = positions[index >= 0 ? index : 0];
                break;
            }
        }
        return {
            ...newState,
            [field]: value,
        };
    },
});
